import { Record } from 'immutable';

const DisclaimersRecord = Record({
    illustration: '',
    highVolume: '',
    optionsVariation: '',
    dataResponsibility: '',
    priceChange: '',
    priceExclusion: '',
    taxesExcluded: '',
    pricePaymentsTaxesExcluded: '',

    cashPurchase: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
    },

    lease: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: '',
    },

    finance: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: '',
    },
});

class Disclaimers extends DisclaimersRecord {}

export default Disclaimers;
